<div class="dialog-container">
  <mat-dialog-content>
    <div class="buttons-container">
      @if (showButtons) {
        <button mat-flat-button title="Générer le PDF" class="generate-button" (click)="generatePdf()">
          <div class="wrapper">
            @if (isPdfLoading()) {
              <mat-spinner class="spinner" diameter="22"></mat-spinner>
            } @else {
              <mat-icon >picture_as_pdf</mat-icon>
            }
            Voir l'aperçu du PDF
          </div>
        </button>
        <button mat-flat-button mat-dialog-close title="Voir l'écran de modification de la procédure" class="check-procedure-button" (click)="goToModificationProcedureView()">
          <div class="wrapper">
            <mat-icon >edit</mat-icon>
            Voir la procédure
          </div>
        </button>
      }
      <button mat-flat-button mat-dialog-close title="Fermer la modale" class="close-modale-button">
        <div class="wrapper">
          <mat-icon >close</mat-icon>
        </div>
      </button>

    </div>
    <mat-card class="logigramme-container" appearance="outlined">
      @if (procedureId) {
        <logigramme-read-only
            [procedureId]="procedureId"
            [showDetails]="showDetails"
            (rappidEventEmitter)="receiveRappidObject($event)"></logigramme-read-only>
      }
    </mat-card>
  </mat-dialog-content>
</div>

